import { ReactNode } from "react";

export type ButtonProps = React.ComponentPropsWithRef<"button"> & {
  children: ReactNode;
  color?: ColorButtonEnum;
  disabled?: boolean;
  onClick?: () => void;
}

export enum ColorButtonEnum {
  PRIMARY_CLASSIC_VIOLET = 'bg-classic-violet-main text-white',
  PRIMARY_ADMIN_GREEN = 'bg-admin-green-main text-white',
  PRIMARY_ADMIN_BLUE = 'bg-admin-blue-main text-white',
  SECONDARY_CLASSIC_VIOLET = 'bg-white text-classic-violet-main border border-classic-violet-main',
  SECONDARY_ADMIN_GREEN = 'bg-white text-admin-green-main border border-admin-green-main',
  SECONDARY_ADMIN_BLUE = 'bg-white text-admin-blue-main border border-admin-blue-main',
}

const Button = ({ children, color = ColorButtonEnum.PRIMARY_CLASSIC_VIOLET, disabled = false, onClick }: ButtonProps): JSX.Element => {
  return <button  className={`m-0 px-2w py-1w w-fit rounded ${color}`}
                  disabled={disabled}
                  onClick={onClick}>
            {children}
          </button>;
};

export default Button;